"use client";

import { getLink } from "@utils/linkUtils";
import { useLocale } from "next-intl";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import Image from "@/components/ui/Image/Image";
import { HighlightDualColumnProps } from "@/types";

export default function MediaHighlightDualColumn({ entry }: HighlightDualColumnProps) {
  const locale = useLocale();
  return (
    <section className="grid grid-cols-1 font-primary md:grid-cols-2">
      <div className="my-xs py-xl text-center uppercase md:col-span-2 md:mt-m md:mb-xs md:pt-3xl md:pb-xxl accent-color accent-font accent-title">
        {entry.overtitle && <h4 className="text-xs mb-m px-m">{entry.overtitle}</h4>}
        <h2 className="text-l md:text-xl">{entry.title}</h2>
      </div>

      {entry.columns.map((column, index) => (
        <div key={`media-${index}`} className="group relative">
          <Image
            alt={column.backgroundImage.title || ""}
            src={column.backgroundImage.url}
            width={column.backgroundImage.width || 683}
            height={column.backgroundImage.height || 381}
            className="aspect-1-1 transition transform hover:duration-[6000ms] md:group-hover:scale-105 group-hover:duration-[1000ms] motion-reduce:transition-none motion-reduce:hover:transform-none min-w-[100%]"
          />
          <div className="absolute w-full h-full top-0 left-0 inset-0 img-overlay-5"></div>
          <div className="absolute top-0 w-full h-full flex flex-col gap-m items-center justify-center md:justify-end md:pb-xxl text-white ">
            {column.logo && (
              <Image
                src={column.logo.url}
                width={column.logo.width || 208}
                height={column.logo.height || 64}
                alt={column.logo.title || ""}
                className="w-[145px] h-[80px] md:w-[208px] mb-xs md:h-[64px]"
              />
            )}
            {column.title && <p className="uppercase text-center text-[20px] md:mt-xl md:text-xl">{column.title}</p>}
            {column.cta && (
              <Button
                href={getLink(column.cta, locale)}
                size={ButtonSize.MEDIUM}
                variant={column.ctaButton ? ButtonVariant.PRIMARY : ButtonVariant.TERTIARY}
                theme={ButtonTheme.WHITE}
                customClass="after:content-[''] after:absolute after:w-full after:h-full after:top-0 after:left-0 border-none"
              >
                {column.cta.label}
              </Button>
            )}
          </div>
        </div>
      ))}
    </section>
  );
}
